<template>
  <div>
    <el-card shadow="always">
      <el-page-header @back="back" title :content="$t('parametros')"></el-page-header>
    </el-card>
    <el-card>
      <el-tabs v-model="active">
        <el-tab-pane label="E-mail" name="first">
          <el-form :model="ruleForm" ref="ruleForm" label-position="top">
            <el-form-item :label="$t('usuario-email')" prop="user">
              <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
                <el-input ref="user" v-model="ruleForm.user"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item :label="$t('senha-email')" prop="password">
              <el-input ref="password" type="password" v-model="ruleForm.password"></el-input>
            </el-form-item>
            <el-form-item :label="$t('email-envio')" prop="mail">
              <el-input ref="mail" v-model="ruleForm.mail"></el-input>
            </el-form-item>
            <el-form-item :label="$t('servidor-email')" prop="host">
              <el-input ref="host" v-model="ruleForm.host"></el-input>
            </el-form-item>
            <el-form-item :label="$t('servidor-porta')" prop="port">
              <el-input ref="port" type="number" v-model="ruleForm.port"></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="Financeiro" name="second">
          <el-form :model="ruleForm" ref="ruleForm" label-position="top">
            <el-form-item :label="$t('valor-multa')" prop="penalty">
              <el-input ref="penalty" type="number" v-model="ruleForm.penalty"></el-input>
            </el-form-item>
            <el-form-item :label="$t('valor-taxa-juros')" prop="fees">
              <el-input ref="fees" type="number" v-model="ruleForm.fees"></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="Postagem" name="third">
          <el-form :model="ruleForm" ref="ruleForm" label-position="top">
            <el-row :gutter="5">
              <el-col :xs="12" :sm="12" :md="8" :lg="5" :xl="5">
                <el-form-item :label="$t('reserva-objetos')" prop="reserve">
                  <el-input ref="reserve" type="number" v-model="ruleForm.reserve"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :sm="12" :md="8" :lg="5" :xl="5">
                  <el-form-item :label="$t('valor-maquinario')" prop="value">
                  <el-input ref="value" type="number" v-model="ruleForm.value"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :xs="12" :sm="12" :md="8" :lg="5" :xl="5">
                <el-form-item :label="$t('minimo-maquinario')" prop="minimum">
                  <el-input ref="minimum" type="number" v-model="ruleForm.minimum"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :sm="12" :md="8" :lg="5" :xl="5">
                <el-form-item :label="$t('maximo-seguro')" prop="insurance">
                  <el-input ref="insurance" type="number" v-model="ruleForm.insurance"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :xs="12" :sm="12" :md="8" :lg="5" :xl="5">
                <el-form-item prop="offline">
                  <el-checkbox ref="offline" v-model="ruleForm.offline">Modo offline</el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="5">
                <el-col :xs="12" :sm="12" :md="8" :lg="5" :xl="5">
                <el-form-item :label="$t('ar')" prop="warning">
                  <el-input ref="warning" type="number" v-model="ruleForm.warning"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :sm="12" :md="8" :lg="5" :xl="5">
                <el-form-item :label="$t('mp')" prop="ownhand">
                  <el-input ref="ownhand" type="number" v-model="ruleForm.ownhand"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                <el-form-item prop="cost" label="Custo Licença" >
                  <el-radio-group v-model="ruleForm.cost">
                    <el-radio label="courier">Utilizar custo do correio</el-radio>
                    <el-radio label="packagetable">Utilizar custo da tabela de preço</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="SVP" name="four">
          <el-form :model="ruleForm" ref="ruleForm" label-position="top">
            <el-form-item :label="$t('usuario')" prop="svpUsername">
              <el-input type="number" v-model="ruleForm.svpUsername"></el-input>
            </el-form-item>
            <el-form-item :label="$t('senha')" prop="value">
              <el-input type="password" v-model="ruleForm.svpPassword"></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="CWS Correios" name="five">
          <el-form :model="ruleForm" ref="ruleForm" label-position="top">
            <el-form-item :label="$t('usuario')" prop="cwsUsername">
              <el-input v-model="ruleForm.cwsUsername" maxlength="40"></el-input>
            </el-form-item>
            <el-form-item :label="$t('senha')" prop="cwsPassword">
              <el-input type="password" v-model="ruleForm.cwsPassword" maxlength="40"></el-input>
            </el-form-item>
            <el-form-item :label="$t('cartao')" prop="cwsCardpost">
              <el-input v-model="ruleForm.cwsCardpost" maxlength="15"></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="Notificação" name="six">
          <el-form :model="ruleForm" ref="ruleForm" label-position="top">
            <el-form-item prop="active">
              <el-col :xs="15" :sm="10" :md="10" :lg="5" :xl="5">
                <el-checkbox v-model="ruleForm.snapbot.active">Usar o Snapbot</el-checkbox>
              </el-col>
            </el-form-item>
            <el-form-item label="Client Id" prop="client_id">
              <el-input type="text" :disabled="!ruleForm.snapbot.active" v-model="ruleForm.snapbot.client_id"></el-input>
            </el-form-item>
            <el-form-item label="Client Secret" prop="client_secret">
              <el-input type="text" :disabled="!ruleForm.snapbot.active" v-model="ruleForm.snapbot.client_secret"></el-input>
            </el-form-item>
            <el-form-item label="Username" prop="username">
              <el-input type="text" :disabled="!ruleForm.snapbot.active" v-model="ruleForm.snapbot.username"></el-input>
            </el-form-item>
            <el-form-item label="Password" prop="password">
              <el-input type="text" :disabled="!ruleForm.snapbot.active" v-model="ruleForm.snapbot.password"></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <br />
      <el-button type="warning" autofocus @click="submitForm('ruleForm')">{{
        $t("atualizar")
      }}</el-button>
      <el-button @click="back()">{{ $t("voltar") }}</el-button>
    </el-card>
  </div>
</template> 
<script>
import { i18n } from "@/plugin/i18n";
import { ParameterService } from "@/services/customers/parameter.services";
import { UserService } from "@/services/users/user.services";

export default {
  name: "Parameters",
  data() {
    return {
      id: "",
      active: "first",
      user: { type: "2'" },
      ruleForm: {
        user: "",
        password: "",
        mail: "",
        port: 0,
        penalty: 0,
        fees: 0,
        reserve: 0,
        insurance: 0,
        offline: false,
        warning: 0,
        cost: "courier",
        ownhand: 0,
        host: "",
        svpUsername: "",
        svpPassword: "",
        cwsUsername: "",
        cwsPassword: "",
        cwsCardpost: "",
        snapbot: {
          active: false,
          client_id: "",
          client_secret: "",
          username: "",
          password: "",
        },
        token: ""
      },
    };
  },
  methods: {
    back() {
      var vm = this;
      vm.$router.push({ name: "home" });
    },
    get() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      ParameterService.get()
        .then((response) => {
          if (response) {
            if (!response.snapbot) {
              response.snapbot = {
                active: false,
                client_id: "",
                client_secret: "",
                username: "",
                password: "",
              }
            } else {
              response.snapbot = JSON.parse(response.snapbot)
            }
            vm.ruleForm = response;
          }
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
            duration: 5000,
          });
        })
        .finally(() => loading.close());
    },
    submitForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading(vm.$options.loading);
          ParameterService.save(vm.ruleForm)
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("parametros-atualizados-sucesso"),
              });
            })
            .catch((error) => {
              this.$message({
                duration: 5000,
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.user.type = response.type;
        vm.get();
      })
      .catch((error) => {
        vm.$message({
          type: "error",
          message: error,
        });
      });
  },
};
</script>
<style scoped>
.el-page-header__left {
  display: flex !important;
}

form {
  margin-top: 20px;
}

@media screen and (min-width: 458px) {
  .col-form-label {
    text-align: right;
  }
}
</style>
